import React from 'react';
// import PropTypes from 'prop-types';
import ButtonGroup from 'scripts/components/lib/buttons/ButtonGroup';
import styles from 'styles/components/lib/buttons/tabs.css';


export const Tabs = ({children, onTabChange, selectedTab = 0, ...props}) => (
  <ButtonGroup className={styles.tabContainer} selectedValue={selectedTab} onChange={onTabChange}>
    {children}
  </ButtonGroup>
);


export const Tab = ({children, isSelected, label, onClick, value,  ...props}) => {
  return (
    <div className={isSelected ? styles.selectedTab : styles.tab} onClick={onClick} value={value}>
      <h6>{label}</h6>
      { children && children }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/scripts/components/lib/buttons/Tabs.js